import scrollElementTo from '../../lib/utils/animation/scrollElementTo';
import debounce from '../../lib/utils/events/debounce';

const SCREEN_WIDTH_SMALL: number = 980;
const CLASS_CURRENT: string = 'current';
// скорость прокрутки страницы
const animateTime: number = 1000;
// состояние прокрутки страницы
let scrollState: number = 0;
// высота экрана
let screenHeight: number;
// активна ли прокрутка?
let isActiveScroll: boolean = false;
// сколько раз прокрутился экран
let countScroll: number = 0;
// сколько экранов вмещается на странице
let countScreenOnPage: number = 0;
// массив с элементами навигации
let arrayNavigationMenuElements: HTMLLIElement[] = [];
// Кнопка прокрутки вниз
let buttonScrollBottom: HTMLButtonElement;

// инициализация
function main(): void
{
	const main: HTMLElement = document.querySelector( 'body>main' ) as HTMLElement;
	
	if ( !main
		|| !document.body.classList.contains( 'index' ) 
		|| document.documentElement.classList.contains( 'ua-mobile' ) )
	{
		return;
	}

	// состояние прокрутки при загрузке страницы
	scrollState = window.pageYOffset;
	// элементы для скролла
	const scrollElementCollection: NodeList = main.querySelectorAll( 'div.screen-container' );
	
	const navigateMenuContainer = document.querySelector( 
		'main>aside.navigation>div.scroll-container>ul.navigation' ) as HTMLElement;
	
	registerHandlers( scrollElementCollection, navigateMenuContainer );
}

// регистрация обработчиков
function registerHandlers( scrollElementCollection: NodeList, navigateMenuContainer: HTMLElement ): void
{
	const boundDocumentClickHandler: ( event: Event ) => void = ( event: Event ) => targetClick( event );
	const boundDocumentScrollHandler: ( event: WheelEvent ) => void =
		debounce( ( event: WheelEvent ) => targetScroll( scrollElementCollection, event ), 100, true );
	// const boundDocumentScrollHandler: ( event: WheelEvent ) => void =
	// 		debounce( targetScroll.bind( null, scrollElementCollection ), 100, true );
	
	let unRegisterHandlers = (): void =>
	{
		buttonScrollBottom.removeEventListener( 'click', boundDocumentClickHandler );
		window.removeEventListener( 'wheel', boundDocumentScrollHandler );
	};
	
	// высота экрана
	screenHeight = updateResizeVariables(
		scrollElementCollection,
		navigateMenuContainer,
		boundDocumentClickHandler,
		boundDocumentScrollHandler,
		unRegisterHandlers
	);
	
	window.addEventListener(
		'resize',
		() =>
			updateResizeVariables(
				scrollElementCollection,
				navigateMenuContainer,
				boundDocumentClickHandler,
				boundDocumentScrollHandler,
				unRegisterHandlers
		)
	);
}

// пересчёт переменных при ресайзе окна
function updateResizeVariables(
	scrollElementCollection: NodeList,
	navigateMenuContainer: HTMLElement,
	boundDocumentClickHandler: ( event: Event ) => void,
	boundDocumentScrollHandler: ( event: WheelEvent ) => void,
	unRegisterHandlers: () => void
): number
{
	if ( !isModeMobile() )
	{
		countScreenOnPage = scrollElementCollection.length;
		screenHeight = document.documentElement.clientHeight;
		countScroll = Math.round( window.pageYOffset / screenHeight );
		scrollState =  countScroll * screenHeight;
		
		if ( arrayNavigationMenuElements.length <= 0 )
		{
			createdNavigationMenu( navigateMenuContainer, countScreenOnPage, boundDocumentClickHandler );
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
		}

		if ( countScroll === ( countScreenOnPage - 1 ) )
		{
			addClassButtonScrollBottom( buttonScrollBottom );
		}

		// Вешаю обработчик на колесо мыши, оборачиваю в функцию для того, чтобы убирать инерцию от скролла
		window.addEventListener( 'wheel', boundDocumentScrollHandler );
		
		scrollElementTo( window, scrollState, 10 );
	}
	else
	{
		removeChildNavigationMenu( arrayNavigationMenuElements, navigateMenuContainer );
		const parentNavigateMenuContainer = (navigateMenuContainer as any).closest('aside.navigation');
		// Если есть, то удалить
		if ( parentNavigateMenuContainer.contains( buttonScrollBottom ) )
		{
			console.log('mobile');
			unRegisterHandlers();
			parentNavigateMenuContainer.removeChild( buttonScrollBottom );
		}
	}
	
	return screenHeight;
}

// создание меню навигации
function createdNavigationMenu(
	navigateMenuContainer: HTMLElement,
	countScreenOnPage: number,
	boundDocumentClickHandler: ( event: Event ) => void
): HTMLElement
{
	for ( let i = 0; i < countScreenOnPage; i++ )
	{
		let bulitElement: HTMLAnchorElement = document.createElement( 'a' );
		let bulitElementContainer: HTMLLIElement = document.createElement( 'li' );

		bulitElement.addEventListener( 'click', ( event: Event ) => targetClick( event ) );
		
		arrayNavigationMenuElements.push( bulitElementContainer );
		
		bulitElementContainer.appendChild( bulitElement );
		navigateMenuContainer.appendChild( bulitElementContainer );
	}

	// Создание элемента button ( кнопки прокрутки вниз )
	const button: HTMLButtonElement = document.createElement( 'button' );
	button.classList.add( 'scroll-bottom' );
	button.textContent = 'Показать ещё';
	button.addEventListener( 'click', boundDocumentClickHandler );
	buttonScrollBottom = button;

	const parentNavigateMenuContainer = (navigateMenuContainer as any).closest('aside.navigation');
	parentNavigateMenuContainer.appendChild( buttonScrollBottom );
	
	return navigateMenuContainer
}

// срабатывает при скролле колесом мыши
function targetScroll( scrollElementCollection: NodeList, event: WheelEvent ): void
{
	event.preventDefault();

	if (
		isActiveScroll 
		|| ( event.deltaY === 0 )
	)
	{
		return;
	}
	
	if ( event.deltaY > 0 )
	{
		if ( scrollState < (scrollElementCollection.length - 1) * screenHeight)
		{
			isActiveScroll = true;
			scrollState += screenHeight;
			
			addClassButtonScrollBottom( buttonScrollBottom );

			arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
			countScroll++;
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
			
			if ( countScroll !== ( countScreenOnPage - 1 ) )
			{
				setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTime );
			}

			toScroll( scrollState );
		}
		else
		{
			scrollState = (scrollElementCollection.length - 1) * screenHeight;
		}
	}
	else if ( event.deltaY > -screenHeight )
	{
		if ( scrollState > 0 )
		{
			isActiveScroll = true;
			scrollState -= screenHeight;

			addClassButtonScrollBottom( buttonScrollBottom );
			setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTime );
			
			arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
			countScroll--;
			arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );
			toScroll( scrollState );
		}
		else
		{
			scrollState = 0;
		}
	}
}

// срабатывает при клике
function targetClick( event: Event ): void
{
	if ( isActiveScroll )
	{
		return;
	}
	
	isActiveScroll = true;
	
	if ( event.target === buttonScrollBottom )
	{
		scrollState += screenHeight;

		addClassButtonScrollBottom( buttonScrollBottom );

		arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
		countScroll++;
		arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );

		if ( countScroll !== ( countScreenOnPage - 1 ) )
		{
			setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTime );
		}
	}
	else
	{
		const element: any = event.target;
		const index: number = arrayNavigationMenuElements.indexOf( element.parentElement );

		scrollState = screenHeight * index;

		addClassButtonScrollBottom( buttonScrollBottom );

		arrayNavigationMenuElements[countScroll].classList.remove( CLASS_CURRENT );
		countScroll = index;
		arrayNavigationMenuElements[countScroll].classList.add( CLASS_CURRENT );

		if ( index !== arrayNavigationMenuElements.length - 1 )
		{
			setTimeout( () => removeClassButtonScrollBottom( buttonScrollBottom ), animateTime );
		}
	}
	
	toScroll( scrollState );
}

// скролит страницу на заданную величину
function toScroll( scrollState: number ): void
{
	scrollElementTo( window, scrollState, animateTime );
	setTimeout(
		() =>
		{
			isActiveScroll = false;
		}, animateTime
	);
}

// Удаление элементов в массиве
function removeChildNavigationMenu( array: HTMLLIElement[], container: HTMLElement ): void
{
	array.forEach(
		( item: HTMLLIElement ) =>
		{
			container.removeChild( item );
		}
	);

	array.length = 0;
}

// Добавление класса кнопки прокрутки вниз
function addClassButtonScrollBottom( button: HTMLButtonElement ): void
{
	button.classList.add( 'hide' );
}
// Удаление класса кнопки прокрутки вниз
function removeClassButtonScrollBottom( button: HTMLButtonElement ): void
{
	button.classList.remove( 'hide' );
}

function isModeMobile()
{
	return ( window.innerWidth < SCREEN_WIDTH_SMALL );
}

export {
	main as default,
};